export const electronicInvoice = [
  {
    path: '/electronicInvoice',
    name: 'electronicInvoice',
    component: () => import('@/views/electronicInvoice'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/electronicInvoice/openInvoice',
    name: 'openInvoice',
    component: () => import('@/views/electronicInvoice/open'),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/electronicInvoice/afterOpenInvoice',
    name: 'afterOpenInvoice',
    component: () => import('@/views/electronicInvoice/afterOpen'),
    meta: {
      title: '开发票'
    }
  },
  {
    path: '/electronicInvoice/selectStore',
    name: 'invoiceSelectStore',
    component: () => import('@/views/electronicInvoice/selectStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/electronicInvoice/invoiceSelectSingleStore',
    name: 'invoiceSelectSingleStore',
    component: () => import('@/views/electronicInvoice/selectSingleStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/electronicInvoice/detail',
    name: 'invoiceDetail',
    component: () => import('@/views/electronicInvoice/detail'),
    meta: {
      title: '开票详情'
    }
  },
  {
    path: '/electronicInvoice/search',
    name: 'invoiceSearch',
    component: () => import ('@/views/electronicInvoice/search'),
    meta: {
      title: '搜索'
    }
  }
]
